<div class="map-main">
    <div class="close-button">
        <button type="button" class="close" aria-label="Close" (click)="dismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="container-fluid">
        <div class="row row--gutter">
            <div class="col-xl-7 col-md-7 col-sm-12 map">
                <div class="map-contaier">
                    <div class="map-title">
                        <h5 class="mb-0">Map Location</h5>
                    </div>
                    <div class="map-wrapper" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
                        <agm-map [latitude]="lat" [longitude]="lng" [zoom]="zoom" (mapReady)="mapReadyFunction($event)"
                            (centerChange)="handleMapCenterChange($event)">
                        </agm-map>
                        <!-- (centerChange)="onMapCenterChange($event)"(idle)="onMapIdle()"(zoomChange)="changeMapZoom($event)" (dragend)="mapready($event)" (mouseWheel)="onMouseWheel($event)"> -->
                        <div class="map-center-overlay">
                            <img src="../assets/images/icons/pin.svg" width="35">
                        </div>
                        <div class="map-top-input-overlay">
                            <div class="form-group">
                                <!-- <label class="control-label">Pickup address</label> -->
                                <app-google-dropdown [childFormControlName]="firstFormGroup.get('address')"
                                    (checkAddressDetail)="setPickupAddress()"
                                    (lettersOnly)="lettersOnlyPickup($event,'pickup_address')"
                                    (placeDetailsEvent)="receivedPlaceDetails($event,'pickup_address')"></app-google-dropdown>
                            </div>
                        </div>
                        <div class="map-dragg">
                            Move the map to fine-tune its position
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-5 col-md-5 col-sm-12">
                <div class="map-contaier">
                    <div class="map-title">
                        <h5 class="mb-0">Pickup Details</h5>
                    </div>
                </div>

                <div class="location-address-details" [ngClass]="{'currentLocationActive': isHovered}">

                    <div class="icon-location">
                        <div class="address-marker">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="currentColor">
                                <path fill="none" d="M0 0h24v24H0z"></path>
                                <path
                                    d="M11 19.9451C6.50005 19.4476 3 15.6326 3 11C3 6.02944 7.02944 2 12 2C16.9706 2 21 6.02944 21 11C21 15.6326 17.5 19.4476 13 19.9451V24H11V19.9451ZM12 18C15.866 18 19 14.866 19 11C19 7.13401 15.866 4 12 4C8.13401 4 5 7.13401 5 11C5 14.866 8.13401 18 12 18Z">
                                </path>
                            </svg>
                        </div>
                        <div class="address-current">
                            <p class="mb-0">
                                {{pickupAddress}}
                            </p>
                        </div>
                    </div>

                    <button type="button" class="btn btn-primary mt-2 w-100" (click)="handlePermission()">Current
                        location</button>

                    <div class="or-line">
                        <p class="mb-0">OR</p>
                    </div>

                    <div class="row row--gutter">
                        <div class="col-lg-5 col-md-5 col-sm-12">
                            <div class="form-group">
                                <label for="latitude">Latitude<span class="required">*</span></label>
                                <input class="form-control" id="latitude" numbersOnly onlyNumbers type="text"
                                    placeholder="latitude" [(ngModel)]="latitude">
                            </div>
                        </div>
                        <div class="col-lg-5 col-md-5 col-sm-12">
                            <div class="form-group">
                                <label for="longitude">Longitude<span class="required">*</span></label>
                                <input class="form-control" id="longitude" numbersOnly onlyNumbers type="text"
                                    placeholder="longitude" [(ngModel)]="longitude">
                            </div>
                        </div>
                        <div class="col-lg-2 col-md-2 col-sm-12">
                            <button class="btn search-btn" (click)="searchLatLongWise()">
                                <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100">
                                    <path fill="currentColor"
                                        d="M35.002 0C15.764 0 0 15.719 0 34.902c0 7.433 2.374 14.339 6.393 20.018L30.73 96.994c3.409 4.453 5.674 3.608 8.508-.234l10.227-17.405a29.778 29.778 0 0 1-10.528-8.685a29.77 29.77 0 0 1-6.1-17.356C23.52 52.261 16.4 44.5 16.4 34.902c0-10.33 8.243-18.548 18.602-18.548c6.736 0 12.558 3.487 15.818 8.757a29.883 29.883 0 0 1 17.098-2.017C63.033 9.669 50.09 0 35.002 0" />
                                    <path fill="currentColor"
                                        d="M66.129 27.495c-6.422-.87-13.175.702-18.72 4.925c-11.09 8.444-13.247 24.366-4.802 35.456c7.905 10.38 22.34 12.883 33.25 6.237l2.083 2.736a2.69 4.051 52.712 0 0 .106 2.494l15.12 19.855a2.69 4.051 52.712 0 0 4.852-.314a2.69 4.051 52.712 0 0 1.594-4.595l-15.12-19.855a2.69 4.051 52.712 0 0-2.376-.765l-2.084-2.737c9.31-8.75 10.737-23.33 2.833-33.71c-4.223-5.546-10.314-8.857-16.736-9.727m-.75 5.537a19.617 19.617 0 0 1 13.013 7.596a19.635 19.635 0 0 1-3.735 27.577a19.635 19.635 0 0 1-27.576-3.735a19.635 19.635 0 0 1 3.734-27.576a19.614 19.614 0 0 1 14.564-3.862"
                                        color="currentColor" />
                                </svg>
                                &nbsp;
                            </button>
                        </div>
                        <div *ngIf="latlongError" class="error-message">Please enter latitude and longitude</div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="form-group mb-0">
                                <label for="address">Manual address</label>
                                <textarea class="form-control" rows="2" id="address" type="text"
                                    placeholder="Enter manual address" [(ngModel)]="manualAddress"></textarea>
                            </div>
                            <div *ngIf="allowPermission" class="error-message">Please allow the location for browser
                                site settings</div>
                        </div>
                    </div>

                    <div class="row mt-3">
                        <div class="col-12">
                            <div class="location-footer">
                                <button type="button" class="btn btn-primary" (click)="dismiss()">Close</button>
                                <button type="submit" class="btn btn-secondary" (click)="updateUser()">Save</button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>